<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-csm__order">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-select v-model="dataForm.selectType" placeholder="请选择状态">
            <el-option
                    v-for="item in allSelectType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.mobileNumber" placeholder="会员电话" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.memberName" placeholder="会员姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.status" placeholder="请选择状态">
            <el-option
                    v-for="item in allStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-button v-if="$hasPermission('csm:order:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>-->
<!--        </el-form-item>-->
<!--        <el-form-item>-->
<!--          <el-button v-if="$hasPermission('csm:order:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
<!--        </el-form-item>-->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
<!--        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
<!--        <el-table-column prop="id" label="" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="buyerMemberName" label="买家姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="buyerMobileNumber" label="买家电话" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sellMemberName" label="卖家姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sellMobileNumber" label="卖家电话" header-align="center" align="center"></el-table-column>
          <el-table-column label="卖家凭证" width="150" header-align="center" align="center">
              <template slot-scope="scope">
                  <img :src="scope.row.certificateImage" alt="" width="100" height="100">
              </template>
          </el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center">
          <template slot-scope="scop">
            <el-tag v-if="scop.row.status==0" type="success" size="small">未打款</el-tag>
            <el-tag v-else-if="scop.row.status==1" type="success" size="small">已打款</el-tag>
            <el-tag v-else-if="scop.row.status==2" type="success" size="small">已收款</el-tag>
            <el-tag v-else-if="scop.row.status==3" type="success" size="small">卖家申诉中</el-tag>
            <el-tag v-else-if="scop.row.status==4" type="success" size="small">申述已通过</el-tag>
            <el-tag v-else-if="scop.row.status==5" type="success" size="small">申诉已拒绝</el-tag>
            <el-tag v-else-if="scop.row.status==6" type="success" size="small">买家支付超时</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="integrationAmount" label="优果数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="price" label="价格" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="sellerMobile" label="卖家手机号" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="bankId" label="卖家银行卡id" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="certificateImage" label="凭证图片" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('csm:order:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">查看凭证</el-button>
<!--            <el-button v-if="$hasPermission('csm:order:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './order-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/csm/order/page',
        getDataListIsPage: true,
        exportURL: '/csm/order/export',
        deleteURL: '/csm/order',
        deleteIsBatch: true
      },
      allSelectType: [{
        value: 0,
        label: '买家'
      }, {
        value: 1,
        label: '卖家'
      }],
        allStatus: [{
        value: '',
        label: ''
      }, {
        value: 0,
        label: '未打款'
      }, {
        value: 1,
        label: '已打款'
      }, {
        value: 2,
        label: '已收款'
      }, {
        value: 3,
        label: '卖家申诉中'
      }, {
        value: 4,
        label: '申述已处理'
      }, {
        value: 5,
        label: '买家支付超时'
      }],
      dataForm: {
        mobileNumber: '',
        memberName: '',
        status: '',
        selectType: 0
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
